export const Template = {
    /**
     * @const
     * @type {number}
     */
    IGNORE: -10, // Must be negative. Only path tiles are positive
    /**
     * @const
     * @type {number}
     */
    OPEN: -9, // Must be negative. Only path tiles are positive
    /**
     * Path tiles are open tiles. We do not always care if an open tile is also a path tile.
     * @const
     * @type {number}
     */
    OPEN_OR_PATH: -11, // Must be negative
    /**
     * @const
     * @type {number}
     */
    CLOSED: -8, // Must be negative. Only path tiles are positive
    /**
     * @const
     * @type {number}
     */
    START: 0,  
    /**
     * @const
     * @type {number}
     */
    END: 1000,   // Must be positive, but use a number that will be greater than any possible path index
    /**
     * @const
     * @type {number}
     */
    PATH: 2000,
}